export { default as rightArrowWhitebg } from "./general/right_arrow_whitebg.svg";
export { default as searchIcon } from "./general/search_black.svg";
export { default as blackCloseIcon } from "../../src/assets/black_cross.svg";
export { default as sweepstakePdf } from "../../src/assets/sweepstake-t&c.pdf";

export { default as newtag } from "./header/newtag.svg";
export { default as contestbackground } from "./general/Group 8215 (1).svg";
export { default as contestbackgroundmob } from "./general/Group 8215.svg";
export { default as AkbarPirani } from "./landing-page/testi/Akbar-Pirani.png";
export { default as BhavanaPatel } from "./landing-page/testi/Bhavana-Patel.png";
export { default as DianaHayden } from "./landing-page/testi/Diana-Hayden.png";
export { default as FamilyKarma } from "./landing-page/testi/Family-Karma.png";
export { default as FatimaAli } from "./landing-page/testi/Fatima-Ali.png";
export { default as MsPooja } from "./landing-page/testi/Ms-Pooja.png";
export { default as NikhilMerchant } from "./landing-page/testi/Nikhil-Merchant.png";
export { default as Priya } from "./landing-page/testi/Priya.png";
export { default as Samira } from "./landing-page/testi/Samira.png";
export { default as ShubhraRamineni } from "./landing-page/testi/Shubhra-Ramineni.png";
export { default as dropDownArrow } from "./landing-page/drop-down-arrow.svg";
export { default as diwalibanner } from "./Diwali/Ticker website_Golden Jublee-banner_v01.jpg";
export { default as diwalibannermob } from "./Diwali/Background-mobile.jpg";
export { default as diwalibannerbig } from "./Diwali/2560x1700.jpg";
export { default as diwalibackground } from "./Diwali/Golden-Jublee-banner-bg@2x.jpg";
export { default as formbackgorund } from "./Diwali/form-backgorund.png";
export { default as forminside } from "./Diwali/form-image.png";
export { default as tooltip } from "./Diwali/tooltip.png";
export { default as buttonbackground } from "./Diwali/button-background.png";
export { default as circlegift } from "./Diwali/circle-gift.png";
export { default as fiftyyears } from "./Diwali/50-years.png";
export { default as grandprice } from "./Diwali/Grand-prize.png";
export { default as chancetowin } from "./Diwali/Chance-to-win.png";
export { default as goldenbonanza } from "./Diwali/Golden-bonanza-text.png";
export { default as entercoupon } from "./Diwali/Enter-coupon.png";
export { default as shilpa } from "./Diwali/Shilpa.png";
export { default as aboutback } from "./Diwali/about-background.png";
export { default as aboutbacknew } from "./Diwali/about-back-new.png";
export { default as formbackmob } from "./Diwali/form-background-mob.png";
export { default as diwalirightarrow } from "./Diwali/diwali-right-arrow.svg";
export { default as diwalileftarrow } from "./Diwali/diwali-left-arrow.svg";
export { default as diwaliplayicon } from "./Diwali/diwali-playicon.png";
export { default as diwaligallery1 } from "./Diwali/diwaligallery1.png";
export { default as diwaligallery2 } from "./Diwali/diwaligallery2.png";
export { default as diwaligallery3 } from "./Diwali/diwaligallery3.png";
export { default as shilpaimage } from "./Diwali/shilpa-shetty-image.png";
export { default as aboutbackmob } from "./Diwali/about-mobile-back-2.png";
export { default as aboutbacksm } from "./Diwali/about-mobile-back.png";
export { default as leftarrow } from "./Diwali/left-arrow.svg";

//diwali 2025 images
export { default as buttonbackground2025 } from "./Diwali-2025/button-background-2025.png";
export { default as diwaliBanner2025_1440 } from "./Diwali-2025/LAXMI_Diwali_KV_2560x1440_v5.mp4";
export { default as diwaliBanner2025 } from "./Diwali-2025/LAXMI_Diwali_KV_1920x960_v5.mp4";
export { default as diwaliBanner2025_1100 } from "./Diwali-2025/LAXMI_Diwali_KV_1600x1100_v5.mp4";
export { default as diwaliBanner2025_650 } from "./Diwali-2025/LAXMI_Diwali_KV_1536x600_v4.mp4";
export { default as diwaliBannerMb2025 } from "./Diwali-2025/LAXMI_Diwali_KV_375x752_Mobile_v5.mp4";
export { default as diwaliBannerMb2025_sm } from "./Diwali-2025/LAXMI_Diwali_KV_375x752_v5.mp4";
export { default as diwaliBannerabout2025 } from "./Diwali-2025/about25/diwali_about_bg_25.png";
export { default as diwaliprodAbout25 } from "./Diwali-2025/about25/prod_about_25.png";
export { default as formbackgorund2025 } from "./Diwali-2025/background.png";
export { default as formLeftDiya } from "./Diwali-2025/Diya_left.png";
export { default as formRightDiya } from "./Diwali-2025/Diya_Right.png";
export { default as formCar } from "./Diwali-2025/FormCar.png";
export { default as DollarandCoins } from "./Diwali-2025/dollarandcoins.png";
export { default as grandPrizeGif } from "./Diwali-2025/grand_prize.gif";
export { default as popupConfetti } from "./Diwali-2025/confetti.png";
export { default as popupclose } from "./Diwali-2025/popup_close.png";
export { default as diwaliBannerGallery25 } from "./Diwali-2025/Gallery25/diwali_banner_gallery_25.png";
export { default as playIcon25 } from "./Diwali-2025/Gallery25/play_icon_25.svg";
export { default as diwaliBannerGallery25Mob } from "./Diwali-2025/Gallery25/diwali_banner_gallery_25_mob.png";
export { default as diwali2025GoldCoin } from "./Diwali-2025/gold_coin_1.png";
export { default as diwali2025PlainCoin } from "./Diwali-2025/plain_coin.png";
export { default as redDottedLine } from "./Diwali-2025/red_dotted_line.png";
export { default as winnerRedDottedLine } from "./Diwali-2025/winner_red_dotted_line.png";
export { default as grandPrize } from "./Diwali-2025/grand_prize.png";
export { default as grandPrizeBg } from "./Diwali-2025/grand_prize_bg.jpg";
export { default as grandPrizeBgMb } from "./Diwali-2025/grand_prize_bg_mb.png";
export { default as questionMark } from "./Diwali-2025/question_mark.png";
// export { default as car2025 } from "./Diwali-2025/car.png";
export { default as car2025 } from "./Diwali-2025/Winner_Car_360_Big.gif";
export { default as formDropDownArrow } from "./Diwali-2025/SelectArrow.svg";
export { default as galleryMarqueeImage } from "./Diwali-2025/Gallery25/banner_marquee.png";
export { default as WinnerDollarCoin } from "./Diwali-2025/WinnerDollarCoin.png";
export { default as MegaWinnerCar2025 } from "./Diwali-2025/MegaWinnerCar2025.gif";

export { default as diwaliBanner2025_1440_img } from "./Diwali-2025/diwali_banner1440.jpg";
export { default as diwaliBanner2025_img } from "./Diwali-2025/diwali_banner.jpg";
export { default as diwaliBanner2025_1100_img } from "./Diwali-2025/diwali_banner1100.jpg";
export { default as diwaliBanner2025_650_img } from "./Diwali-2025/diwali_banner650.jpg";
export { default as diwaliBannerMb2025_img } from "./Diwali-2025/diwali_banner_mb.jpg";
export { default as diwali2025GalleryBanner1Img } from "./Diwali-2025/Gallery25/Banner1.png";
export { default as diwali2025GalleryBanner2Img } from "./Diwali-2025/Gallery25/Banner2.png";
export { default as diwaliBanner2025_img01 } from "./Diwali-2025/diwali_banner_img01.jpg";
export { default as diwaliBanner2025_img01_1920x960 } from "./Diwali-2025/diwali_banner_img01_1920x960.png";
export { default as diwaliBanner2025_img01_1536x600 } from "./Diwali-2025/diwali_banner_img01_1536x600.png";
export { default as diwaliBanner2025Mb_img01 } from "./Diwali-2025/diwali_banner_Mb_img01_750x1504.png";

export { default as diwali2025GalleryBanner3Img } from "./Diwali-26/gall_prev_01.jpg";
export { default as diwali2026GalleryBanner1Img } from "./Diwali-26/prev_gallery_inner_2.jpg";
export { default as diwali2026GalleryBanner4Img } from "./Diwali-26/Banner1.png";
export { default as diwali2026GalleryBanner2Img } from "./Diwali-26/Banner2.png";
export { default as diwali2026GalleryPrev01Img } from "./Diwali-26/gall_prev_01.jpg";
export { default as diwali2026GalleryPrev02Img } from "./Diwali-26/gall_prev_02.jpg";
export { default as diwali2026GalleryPrev03Img } from "./Diwali-26/gall_prev_03.jpg";
export { default as whiteLeftArrow } from "./Diwali-26/left_arrow.svg";
export { default as diwaliPress2026 } from "./Diwali-26/press_release_1.jpg";
export { default as diwali2026InnerGallery2Img } from "./Diwali-26/prev_gallery_inner_2.jpg";

//homepage images
export { default as biggestdhamaka1 } from "./homepage/biggest_dhamaka.jpg";
export { default as biggestdhamakamob } from "./homepage/diwalibanner-mob.jpg";
export { default as diwalibonanzadesk } from "./homepage/diwali-bonanza-1920-X-780.png";
export { default as diwalibonanzamob } from "./homepage/diwali-bonanza-720-X-1228.png";
export { default as diwalihomepage } from "./homepage/laxmi-new-1920x780.jpg";
export { default as diwalihomepagemob } from "./homepage/laxmi-new-720x1228.jpg";
export { default as winnerhomepage } from "./homepage/winner-banner-desktop.jpg";
export { default as winnerhomepagemob } from "./homepage/winner-banner-mob.jpg";

export { default as ramadanBannerDesktop } from "./homepage/Ramadan_banner_desk.png";
export { default as frozenRangeBannerDesktop } from "./homepage/frozen-range-laxmi-desktop.jpg";
export { default as exploreBanner } from "./homepage/Explore_banner.jpg";
export { default as ramadanBannerMobile } from "./homepage/Ramadan_banner_mob.png";
export { default as frozenRangeBannerMobile } from "./homepage/frozen-range-laxmi-mobile.jpg";
export { default as mbExploreBanner } from "./homepage/mbexplore_banner.jpg";
export { default as cricketBanner } from "./homepage/cricket_desktop.jpg";
export { default as mbCricketBanner } from "./homepage/cricket_mobile.jpg";
export { default as homeDiwaliBanner } from "./homepage/diwali_banner.mp4";
export { default as homeDiwaliBannerMb } from "./homepage/mb_diwali_banner.mp4";

//Winners Page
export { default as shilpawinner } from "./Diwali/winners/shilpa_winner.png";
export { default as shilpawinnermob } from "./Diwali/winners/shilpawinner-mob.png";
export { default as voucherwinner } from "./Diwali/winners/voucher_winner.svg";
export { default as newvoucherwinner } from "./Diwali/winners/new-voucher_winner.svg";
export { default as goldvoucher } from "./Diwali/winners/gold_card.svg";
export { default as coin } from "./Diwali/winners/coin.png";
export { default as goldwinnerback } from "./Diwali/winners/gold_winner_back.png";
export { default as megawinnerback } from "./Diwali/winners/mega-winner-background.svg";
export { default as downarrow } from "./Diwali/winners/dropdown-arrow.png";
export { default as voucherwinnerpng } from "./Diwali/winners/voucher_winner-png.png";
export { default as megashilpa } from "./Diwali/winners/mega-shilpa-desk.png";

export { default as contestclosed } from "./homepage/contest-close-1920-780.jpg";
export { default as contestclosedmob } from "./homepage/contest_closed-mob.jpg";
export { default as LoaderGif } from "./Diwali-2025/loader.gif";

// Landing page images
export { default as whiteplayicon } from "./landing-page/whiteplayicon.png";
export { default as redleftarrow } from "./landing-page/redleftarrow.svg";
export { default as redrightarrow } from "./landing-page/redrightarrow.svg";
export { default as testidesign } from "./landing-page/testidesign.png";
export { default as testiimg2 } from "./landing-page/testiimg2.png";
export { default as testiimg3 } from "./landing-page/testiimg3.png";
export { default as testiimg4 } from "./landing-page/testiimg4.png";
export { default as anjana } from "./landing-page/testi/anjana.png";
export { default as ayesha } from "./landing-page/testi/Ayesha.png";
export { default as mariumArif } from "./landing-page/testi/Marium Arif.png";
export { default as kunalLamba } from "./landing-page/testi/Kunal Lamba.png";
export { default as aarthiSampath } from "./landing-page/testi/Aarthi Sampath.png";
export { default as pujaReza } from "./landing-page/testi/PujaReza.png";
export { default as omiVaidya } from "./landing-page/testi/Omi Vaidya.png";
export { default as ashaShiv } from "./landing-page/testi/Asha Shiv.png";
export { default as unmuktChand } from "./landing-page/testi/Unmukt Chand.png";
export { default as rabiaAmmar } from "./landing-page/testi/Rabia Ammar.png";
export { default as fiftycontestclosed } from "./landing-page/testi/50y_contest_closed-desk.png";
export { default as fiftycontestclosedmob } from "./landing-page/testi/50y_contest_closed-mob.png";
export { default as kunallamba } from "./Diwali/kunal-lamba.jpg";
export { default as archanamundhe } from "./Diwali/archana-mundhe.jpg";
export { default as kirannivi } from "./Diwali/kiran-and-nivi.jpg";
export { default as diwalibannernew } from "./Diwali/golden-new-banner.jpg";
export { default as diwalibannernewmobile } from "./Diwali/golden-new-banner-mobile.jpg";
export { default as megabannernew } from "./Diwali/golden-new-banner-new.jpg";
export { default as megabannernewmobile } from "./Diwali/golden-new-banner-mobile-new.jpg";

// Kitchen Categories
export { default as KunalKapurBanner } from "./kitchenCategories/kunalkapur.png";
export { default as SaadatSiddiqiBanner } from "./kitchenCategories/saadatsiddiqi.png";
export { default as WhiteArrow } from "./kitchenCategories/Arrow.svg";

export { default as BesanBanner } from "./kitchenCategories/BESAN-THUMBNAIL-ADAPT.jpg.jpeg";
export { default as BasmatiBanner } from "./kitchenCategories/EL-THUMBNAIL-ADAPT.jpg.jpeg";
export { default as GgpBanner } from "./kitchenCategories/GGP-Thumbnail-ADAPT.jpg.jpeg";

// general
export { default as downloadIcon } from "../images/general/download-icon.svg";
export { default as productPDF } from "../images/general/LAXMI-CATALOG-2024-FINAL-2.pdf";

//diwali 2026 images
export { default as carGif26 } from "./Diwali-26/car_winner_2026_2.gif";
export { default as background2026 } from "./Diwali-26/diwali_bg.png";
export { default as background2026Mb } from "./Diwali-26/diwali_bg_mb.png";
export { default as leftAnimationImgMob } from "./Diwali-26/left_animation_img_mob.png";
export { default as titTokIcon } from "./Diwali-26/tik_tok_icon.svg";
export { default as abt26 } from "./Diwali-26/about_products.png";
export { default as palyIconRed } from "./Diwali-26/play_icon_red.svg";
export { default as carImg26 } from "./Diwali-26/car_img_26.png";
export { default as leftAnimationImg } from "./Diwali-26/left_animation_img.png";
export { default as goldCoinsCards } from "./Diwali-26/gold_coins_cards.png";
export { default as goldCoins } from "./Diwali-26/gold_coins.png";
export { default as grandPrizeIcon26 } from "./Diwali-26/grand_prize_icon_26.png";
export { default as grandPrizeIcon26Mob } from "./Diwali-26/grand_prize_icon_26_mob.png";
export { default as winnersCard1 } from "./Diwali-26/gift_card_1.png";
export { default as winnersCard2 } from "./Diwali-26/gift_card_2.png";
export { default as winnersCard3 } from "./Diwali-26/gift_card_3.png";
export { default as winnersCard1Mob } from "./Diwali-26/gift_card_1_mob.png";
export { default as winnersCard2Mob } from "./Diwali-26/gift_card_2_mob.png";
export { default as winnersCard3Mob } from "./Diwali-26/gift_card_3_mob.png";
export { default as giftCardBedge } from "./Diwali-26/gift_card_winner.svg";
export { default as borderBlack } from "./Diwali-26/border_dashed_blacks.png";
export { default as diwaliOtpCloseIcon } from "./Diwali-26/close_icon.svg";
export { default as diwaliOtpWarningIcon } from "./Diwali-26/warning_icon.svg";
export { default as diwaliOtpSuccessIcon } from "./Diwali-26/success_icon.svg";

export let images = {
  diwalibanner: {
    image: require("./Diwali/Ticker website_Golden Jublee-banner_v01.jpg"),
    alt: "diwali banner img",
  },

  // Kitchen Besan Images
  besanBonda: {
    image: require("./kitchenCategories/besan/BESAN-BONDA.jpg"),
    alt: "BESAN BONDA",
  },
  chocholateMysorePak: {
    image: require("./kitchenCategories/besan/CHOCOLATE-MYSORE-PAK.jpg"),
    alt: "CHOCOLATE MYSORE PAK",
  },
  laddooMuffins: {
    image: require("./kitchenCategories/besan/LADDOO-MUFFINS.jpg"),
    alt: "LADDOO MUFFINS",
  },
  christmasDessertPie: {
    image: require("./kitchenCategories/besan/Christmas-Dessert-Pie.jpg"),
    alt: "LADDOO MUFFINS",
  },
  gujaratiStyleDhoklas: {
    image: require("./kitchenCategories/besan/Gujarati-Style-Dhoklas.jpg"),
    alt: "LADDOO MUFFINS",
  },
  besanTvc: {
    image: require("./kitchenCategories/besan/Besan-Tvc.jpg"),
    alt: "LADDOO MUFFINS",
  },

  // Kitchen Extra long basmati Images
  lebaneseDessert: {
    image: require("./kitchenCategories/extra-long-basmati/Lebanese-Dessert.jpg"),
    alt: "Lebanese Dessert",
  },
  afghanPulao: {
    image: require("./kitchenCategories/extra-long-basmati/Afghan-Pulao.jpg"),
    alt: "Afghan Pulao",
  },
  hariraSoup: {
    image: require("./kitchenCategories/extra-long-basmati/Harira-Soup.jpg"),
    alt: "Harira Soup",
  },
  payasam: {
    image: require("./kitchenCategories/extra-long-basmati/Payasam.jpg"),
    alt: "Payasam",
  },
  desiArancini: {
    image: require("./kitchenCategories/extra-long-basmati/Desi-Arancini.jpg"),
    alt: "Payasam",
  },

  // Kitchen GGP Images
  chickenMalaiTangri: {
    image: require("./kitchenCategories/ggp/Chicken-Malai-Tangri.jpg"),
    alt: "Chicken Malai Tangri",
  },
  hyderabadiSubzBiryani: {
    image: require("./kitchenCategories/ggp/Hyderabadi-Subz-Biryani.jpg"),
    alt: "Hyderabadi Subz Biryani",
  },
  lacchaParatha: {
    image: require("./kitchenCategories/ggp/Laccha-Paratha.jpg"),
    alt: "Laccha Paratha",
  },
  desiAranciniGGP: {
    image: require("./kitchenCategories/ggp/Desi-Arancini.jpg"),
    alt: "Desi Arancini",
  },

  // Press release images
  yahooFinance: {
    image: require("./Diwali-26/yahoo_finance.png"),
    alt: "yahoo finance",
  },
  businessInsider: {
    image: require("./Diwali-26/business_insider.png"),
    alt: "business insider",
  },
  apNews: {
    image: require("./Diwali-26/Ap_news.png"),
    alt: "Ap news",
  },
  digitalJournal: {
    image: require("./Diwali-26/digital_journal.png"),
    alt: "digital journal",
  },
  streetinsider: {
    image: require("./Diwali-26/streetinsider.png"),
    alt: "streetinsider",
  },
  bostonHerald: {
    image: require("./Diwali-26/Boston_Herald.png"),
    alt: "Boston Herald",
  },
  internationalBusiness: {
    image: require("./Diwali-26/International_business.png"),
    alt: "International business",
  },
  businessInsurance: {
    image: require("./Diwali-26/business_insurance.png"),
    alt: "business insurance",
  },
  lezard: {
    image: require("./Diwali-26/lezard.png"),
    alt: "lezard",
  },
  thesandiego: {
    image: require("./Diwali-26/the_san_diego.png"),
    alt: "the san dieg ",
  },
};
